import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

export function BlogList() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);
  return (
    <div data-testid="blog-page" className="fade-in py-20">
      <div className="container-gos">
        <div className="overline mb-3">Insights</div>
        <h1 className="font-display text-4xl sm:text-5xl text-gos-charcoal tracking-tight">Notes from a global office.</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {posts.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="card-lift bg-white border border-gos-border rounded-sm overflow-hidden">
              {p.cover_image_url && <img src={p.cover_image_url} alt={p.title} className="aspect-[16/10] object-cover w-full" />}
              <div className="p-6">
                <div className="overline text-gos-sand mb-2">{p.category} · {p.read_minutes} min</div>
                <div className="font-display text-xl text-gos-navy leading-snug">{p.title}</div>
                <p className="text-sm text-gos-slate mt-3 line-clamp-3">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)); }, [slug]);
  if (!post) return <div className="py-32 text-center text-gos-muted">Loading…</div>;
  return (
    <article data-testid={`blog-detail-${slug}`} className="fade-in py-20">
      <div className="container-gos max-w-3xl">
        <div className="overline text-gos-sand">{post.category} · {post.read_minutes} min read</div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-gos-charcoal mt-3">{post.title}</h1>
        {post.cover_image_url && <img src={post.cover_image_url} alt={post.title} className="w-full aspect-[16/9] object-cover mt-8 rounded-sm" />}
        <div className="prose mt-10 text-base text-gos-slate leading-relaxed whitespace-pre-line">{post.content}</div>
      </div>
    </article>
  );
}
